import EligibleTiers from './components/EligibleTiers';
import Reward from './components/Reward';
import SaleThreshold from './components/SaleThreshold';

const Kickback = () => (
    <>
      <Reward />
      <EligibleTiers />
      <SaleThreshold />
    </>
  );

export default Kickback;
